<template>
<div>
  <div class="scale">
    <div class="icons">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :key="index"
        v-for="index in maxValue"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9.92383 11.1836C10.2819 10.7969 10.4609 10.292 10.4609 9.66895C10.4609 9.11751 10.3177 8.68066 10.0312 8.3584C9.74479 8.02897 9.29004 7.77832 8.66699 7.60645L8.40918 7.53125V5.39355C8.7959 5.42936 9.2793 5.54753 9.85938 5.74805L10.2568 4.75977C9.66243 4.51628 9.05371 4.36589 8.43066 4.30859V3.30957H7.5498V4.30859C6.90527 4.38021 6.40755 4.60579 6.05664 4.98535C5.70573 5.35775 5.53027 5.85905 5.53027 6.48926C5.53027 7.03353 5.6735 7.4668 5.95996 7.78906C6.24642 8.11133 6.70117 8.3584 7.32422 8.53027L7.57129 8.60547V10.8506C6.99837 10.8076 6.42188 10.6286 5.8418 10.3135L5.43359 11.291C5.72721 11.4772 6.05664 11.624 6.42188 11.7314C6.78711 11.8389 7.16309 11.9033 7.5498 11.9248V12.9131H8.43066V11.9033C9.0752 11.8102 9.57292 11.5703 9.92383 11.1836ZM6.92676 6.9082C6.79785 6.75065 6.7334 6.54655 6.7334 6.2959C6.7334 6.02376 6.80143 5.81608 6.9375 5.67285C7.07357 5.52962 7.28483 5.43652 7.57129 5.39355V7.29492C7.27051 7.1875 7.05566 7.05859 6.92676 6.9082ZM9.04297 10.5068C8.9069 10.6572 8.69564 10.7575 8.40918 10.8076V8.8418C8.71712 8.94206 8.93555 9.07096 9.06445 9.22852C9.19336 9.38607 9.25781 9.59733 9.25781 9.8623C9.25781 10.1344 9.1862 10.3493 9.04297 10.5068Z"
          fill="#6E6A69"
          v-if="index <= scale"
        />

        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9.92383 11.1836C10.2819 10.7969 10.4609 10.292 10.4609 9.66895C10.4609 9.11751 10.3177 8.68066 10.0312 8.3584C9.74479 8.02897 9.29004 7.77832 8.66699 7.60645L8.40918 7.53125V5.39355C8.7959 5.42936 9.2793 5.54753 9.85938 5.74805L10.2568 4.75977C9.66243 4.51628 9.05371 4.36589 8.43066 4.30859V3.30957H7.5498V4.30859C6.90527 4.38021 6.40755 4.60579 6.05664 4.98535C5.70573 5.35775 5.53027 5.85905 5.53027 6.48926C5.53027 7.03353 5.6735 7.4668 5.95996 7.78906C6.24642 8.11133 6.70117 8.3584 7.32422 8.53027L7.57129 8.60547V10.8506C6.99837 10.8076 6.42188 10.6286 5.8418 10.3135L5.43359 11.291C5.72721 11.4772 6.05664 11.624 6.42188 11.7314C6.78711 11.8389 7.16309 11.9033 7.5498 11.9248V12.9131H8.43066V11.9033C9.0752 11.8102 9.57292 11.5703 9.92383 11.1836ZM6.92676 6.9082C6.79785 6.75065 6.7334 6.54655 6.7334 6.2959C6.7334 6.02376 6.80143 5.81608 6.9375 5.67285C7.07357 5.52962 7.28483 5.43652 7.57129 5.39355V7.29492C7.27051 7.1875 7.05566 7.05859 6.92676 6.9082ZM9.04297 10.5068C8.9069 10.6572 8.69564 10.7575 8.40918 10.8076V8.8418C8.71712 8.94206 8.93555 9.07096 9.06445 9.22852C9.19336 9.38607 9.25781 9.59733 9.25781 9.8623C9.25781 10.1344 9.1862 10.3493 9.04297 10.5068Z"
          fill="#D7D2CB"
          v-if="index > scale"
        />
      </svg>
    </div>
  </div>
  </div>
</template>


<script>
export default {
  name: "PriceScale",
  props: ["scale", "maxValue"],
  data() {
    return {};
  },
  computed: {},
  mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.icons,
.icons-2 {
  display: flex;
  justify-content: flex-start;
  gap: 4px;
  padding: 10px 0;
}

.icons {
  position: relative;
}

.icons-2 {
  position: absolute;
  bottom: 7px;
}
</style>
